// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import { Modal, AppIcon } from '@loa/ui-components';

type MaxFundingUnsavedChangesModalProps = Readonly<{
  open: boolean;
  busy: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;
}>;

export function MaxFundingUnsavedChangesModal({
  open,
  busy,
  onClose,
  onDiscard,
  onSave,
}: MaxFundingUnsavedChangesModalProps) {
  const handleClose = () => {
    if (busy) return;
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} size="medium">
      <Modal.Header
        title={
          <span className="flex items-center gap-sm">
            <AppIcon name="severity warning" size={20} color="#141414" />
            Scenario Not Saved
          </span>
        }
        onClose={busy ? undefined : handleClose}
      />
      <Modal.Content>
        <p
          className="text-body-02 text-black font-sans leading-normal m-0"
          data-testid="unsaved-modal"
        >
          You have not saved this scenario. If you continue without saving, the scenario
          data will be lost.
        </p>
      </Modal.Content>
      <Modal.Actions
        secondaryAction={{
          label: 'Discard Scenario',
          onClick: onDiscard,
          disabled: busy,
        }}
        primaryAction={{
          label: 'Save Scenario',
          onClick: onSave,
          loading: busy,
          disabled: busy,
        }}
      />
    </Modal>
  );
}
